import templateUrl from './scene.component.html';

export default {
	bindings: {
		scene: '<'
	},
	templateUrl
};
